<template>    
    <div class="modal fade" id="static-update" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-md-dhk modal-dialog-dhk">
            <div class="modal-content">
                <div class="modal-header">
                    <Breadcrumb :breadcrumb="breadcrumb"/>
                    <div class="modal-title w-100">
                        <h2 class="title--1">
                            {{title}}
                        </h2>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text">
                            {{update_default_message}}
                        </p>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <img width="15px" src="/assets/img/svg/close.svg" alt="">
                    </button>
                </div>
                <div class="modal-body">
                    <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">

                        <FormDynamic
                            :form_format="form_format"
                            :form_data="single_object"
                            :array_options="array_options"
                            :for_update="true"
                            name="forUpdate"
                        />
                        <CentralButtons />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import CentralButtons   from '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
        "roles"
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
            update_default_message: `In this view, you can view and modify the details of your selected item. To edit a field, simply click on it, make your changes, and hit save.`
        }
    },
    
    methods:{
        initModalUpdate()
        {
            let roles = JSON.parse(JSON.stringify(this.roles))
            let found_index = roles.findIndex(role => role.id == this.single_object.id)

            if(found_index > -1)
            {
                roles.splice(found_index, 1)
            }

            this.array_options = {
                roles_id: roles
            }
        },

    },

    mounted(){

    }
    
}
</script>
